import { NAV_ITEMS } from '@/constants';
import * as dataSelectors from '@/data/data-selectors';
import exceptionIcon from '@iconify/icons-ant-design/exception-outlined';
import { useSelector } from 'react-redux';
import { NavItem } from '../../nav-item';
import { useVerticalBarNavigation } from '../use-vertical-bar-navigation';

export const ComplaintsNavItem = () => {
  const { goToTab, pathname } = useVerticalBarNavigation();

  const strComplaintsAvailable = useSelector(
    dataSelectors.strComplaintsAvailable
  );

  return (
    <NavItem
      id="complaints"
      icon={exceptionIcon}
      tooltip="Complaints"
      ariaLabel="Go to Complaints View"
      hide={!strComplaintsAvailable}
      isActive={pathname.includes(NAV_ITEMS.complaints)}
      onClick={() => {
        goToTab(NAV_ITEMS.complaints);
      }}
    />
  );
};
